import React from 'react';
import AllAnnouncements from './AllAnnouncements';

const Index = () => {
  return (
    <div>
      <AllAnnouncements />
    </div>
  );
};

export default Index;
